import React from "react";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";
import {Autocomplete} from "@material-ui/lab";
import {ubicacionesResources, rangosResources} from "../endpoints";
import SnackbarAlert from "./SnackbarAlert";

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            prefix=""
        />
    );
}

class AgregarEditarRango extends React.Component{
    constructor(props) {
        super(props);
        if (props.editar){
            this.state= {
                inicial: props.rango.inicial,
                final: props.rango.final,
                comentario: props.rango.comentario,
                id_ubicacion: props.rango.id_ubicacion,
                ubicaciones_hijas: [],
                ubicacion: null,
                openSnack:false,
                severity: null,
                message:null,
            }
        }
        else {
            this.state= {
                inicial: "",
                final: "",
                comentario: "",
                ubicaciones_hijas: [],
                ubicacion: null,
                openSnack:false,
                severity: null,
                message:null,
            }
        }
    }
    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }
    handleClick = () =>{
        const rango ={
            inicial : this.state.inicial,
            final : this.state.final,
            comentario: this.state.comentario,
            id_ubicacion: this.state.ubicacion.id
        }
        if(this.props.editar){
            const id_rango = this.props.rango.id
            rangosResources.editarRango(id_rango, rango).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else {
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
            this.props.handleClose()
        }
        else {
            rangosResources.agregarRango(rango).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.setState( {
                        inicial: "",
                        final: "",
                        comentario: "",
                    });
                    this.props.refrescar(result.message,result.severity)
                }
                else {
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
            this.props.handleClose()
        }
    }

    obtenerUbicacionesHijas=()=>{
        this.setState({openSnack:false, severity: null, message:null})
        ubicacionesResources.obtenerUbicacionesHijas().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({ubicaciones_hijas:result.ubicaciones})
                if(this.props.editar){
                    this.getSelectedItem(this.state.ubicaciones_hijas)
                }
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }
    getSelectedItem =(ubicaciones_hijas)=>{
        for (var i =0;i<ubicaciones_hijas.length;i++){
            if(ubicaciones_hijas[i].id === this.state.id_ubicacion){
                this.setState({ubicacion: ubicaciones_hijas[i]})
            }
        }
    }
    handleClose = () =>{
        this.props.handleClose()
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            if(this.state.inicial && this.state.final && this.state.ubicacion){
                this.handleClick()
            }
        }
    }

    componentDidMount(){
        this.obtenerUbicacionesHijas()
        document.addEventListener('keyup', this.getEventType, false);    // third
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }


    render() {
        return(
            <div>
            <Card style={{width:this.props.width}}>
                <CardContent style={{margin:2}}>
                    <Typography variant={"h6"} style={{marginBottom:4}}>{this.props.title}</Typography>
                    <Grid container direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
                        <Grid item xs={3}>
                            <TextField
                                autoFocus={true}
                                label="Tag inicial"
                                onChange={this.handleChange}
                                value={this.state.inicial}
                                name="inicial"
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                            />
                        </Grid>
                        <Grid item  xs={3}>
                            <TextField
                                onChange={this.handleChange}
                                label="Tag final"
                                name="final"
                                value={this.state.final}
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Autocomplete
                                id="size-small-standard"
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({ubicacion: null})
                                    }
                                    else{
                                        this.setState({ubicacion: newValue})
                                    }
                                }}
                                value={this.state.ubicacion}
                                size="small"
                                options={this.state.ubicaciones_hijas}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.p || ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Ubicación" placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField onChange={this.handleChange} value={this.state.comentario} name="comentario" label="Comentarios" fullWidth/>
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <Grid container direction={"row"} spacing={2} alignItems={"center"} justifyContent={"flex-end"}>
                        <Grid item>
                          <Button variant="contained" color="secondary"  onClick={this.props.handleClose}>Cancelar</Button>
                        </Grid>
                        <Grid item>
                            <Button disabled={!this.state.inicial || !this.state.final || !this.state.ubicacion} onClick={this.handleClick} variant="contained" color="primary">Guardar</Button>
                        </Grid>
                    </Grid>
                </CardActions>
            </Card>
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default AgregarEditarRango;